import React, { useState } from 'react'
import { Button } from '../../lib/ui/button'
import { Toaster } from '../../lib/ui/toast'
import {
  //ArrowUpTrayIcon,
  DocumentTextIcon,
  PlusIcon,
} from '@heroicons/react/24/outline'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../lib/ui/dialog'
import DropzoneThankYouNoteUpload from './DropzoneThankYouNoteUpload'
import { MagicWand } from 'iconoir-react'
import { TranslationProvider } from '../shared/TranslationProvider'
import { useTranslation } from '~/hooks/useTranslation'
import translations from './locales.json'

const NewThankYouNoteOptions = ({ _uploadThankYouNoteClick }) => {
  const { t } = useTranslation('NewThankYouNoteModal')

  return (
    <div className="px-4 pb-4">
      <div className="mb-4 text-lg font-medium">
        {t('choose_your_approach')}
      </div>
      <div className="pb-4">{t('instructions')}</div>
      <div className="pb-4">
        <a
          href="/interview/thank_you_notes/ai"
          className="flex h-28 w-full flex-row rounded-2.5xl bg-willow-brook text-primary"
        >
          <div className="flex items-center justify-center p-6">
            <MagicWand width="2.5rem" height="2.5rem" />
          </div>
          <div className="flex flex-col items-start justify-evenly">
            <div className="font-roboto-slab text-xl font-medium">
              {t('custom_note_with_ayla')}
            </div>
            <div>{t('custom_note_with_ayla_description')}</div>
          </div>
        </a>
      </div>
      <div className="pb-4">
        <a
          href="/interview/thank_you_note_builder/new"
          className="flex h-28 w-full flex-row rounded-2.5xl bg-lily-blue text-primary"
        >
          <div className="flex items-center justify-center p-6">
            <PlusIcon className="w-10" />
          </div>
          <div className="flex flex-col items-start justify-evenly">
            <div className="text-roboto-slab text-xl font-medium">
              {t('create_new_note')}
            </div>
            <div>{t('choose_and_fill_in_blank_template')}</div>
          </div>
        </a>
      </div>
      <div className="pb-4">
        {/*<button
          onClick={uploadThankYouNoteClick}
          className="flex h-28 w-full flex-row rounded-2.5xl bg-lily-blue text-primary"
        >
          <div className="flex items-center justify-center p-6">
            <ArrowUpTrayIcon className="w-10" />
          </div>
          <div className="flex flex-col items-start justify-evenly">
            <div className="text-roboto-slab text-xl font-medium">
              {t('upload_an_existing_note')}
            </div>
            <div>
              {t('upload_valid_file_formats')}
            </div>
          </div>
        </button>*/}
      </div>
    </div>
  )
}

const NewThankYouNoteInner = (props) => {
  const { open, toggleOpen, uploadThankYouNoteClick, uploadThankYouNoteMode } =
    props
  const { t } = useTranslation('NewThankYouNoteModal')

  return (
    <Dialog
      open={open}
      onOpenChange={toggleOpen}
      className="!w-auto rounded-2xl lg:max-w-[37rem] xl:max-w-[37rem]"
    >
      <DialogTrigger asChild className="cursor-pointer">
        <Button>{t('modal_button_text')}</Button>
      </DialogTrigger>
      <DialogContent
        className="font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">
              {t('modal_title')}
              <DocumentTextIcon className="ml-2 inline w-6" />
            </h2>
          </DialogTitle>
        </DialogHeader>
        {!uploadThankYouNoteMode && (
          <NewThankYouNoteOptions
            uploadThankYouNoteClick={uploadThankYouNoteClick}
          />
        )}
        {uploadThankYouNoteMode && <DropzoneThankYouNoteUpload />}
      </DialogContent>
      <Toaster />
    </Dialog>
  )
}

const NewThankYouNoteModal = (props) => {
  const { locale } = props
  const [open, setOpen] = useState(false)
  const [uploadThankYouNoteMode, setUploadThankYouNoteMode] = useState(false)

  const uploadThankYouNoteClick = () => {
    setUploadThankYouNoteMode(true)
  }

  const toggleOpen = () => {
    setOpen(!open)
    setUploadThankYouNoteMode(false)
  }

  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope={'javascript.components.ThankYouNoteBuilder'}
    >
      <NewThankYouNoteInner
        open={open}
        toggleOpen={toggleOpen}
        uploadThankYouNoteClick={uploadThankYouNoteClick}
        uploadThankYouNoteMode={uploadThankYouNoteMode}
      />
    </TranslationProvider>
  )
}
export default NewThankYouNoteModal
